import { useState } from "react";
import CalendarComponent from "./CalendarComponent";
import { Column, Divider, Padding, Row, SizedBox } from "../CommonBaseComponents";
import { C4Text } from "../text/CustomText";
import { format } from "date-fns";
import SecondaryButton from "../button/SecondaryButton";
import PrimaryButton from "../button/PrimaryButton";
import styled from "styled-components";
import { Theme } from "../../Theme";

export const CalendarWrapper = styled.div`
    position: absolute;
    top: ${({ top }) => top || "100%"};
    left: ${({ openedCalendarLeftSide, $leftPositon, $notLeftPositon }) =>
        openedCalendarLeftSide ? $leftPositon : $notLeftPositon};
    z-index: 1000;
    margin-top: 8px;
    width: 340px;
    background-color: ${({ backgroundColor }) => backgroundColor || Theme.color.white_07};
    border-radius: 12px;
    backdrop-filter: ${({ $noBlur }) => ($noBlur ? "none" : "blur(30px)")};
    -webkit-backdrop-filter: ${({ $noBlur }) => ($noBlur ? "none" : "blur(30px)")};
    box-shadow: 0 3px 16px ${Theme.color.black_01};
    padding: 16px;
    box-sizing: border-box;
`;

export const DateInput = styled.input`
    font-size: 13px;
    color: #171a1c;
    padding: 8px 10px;
    border: 1px solid #e6e6e9;
    border-radius: 8px;
    background-color: #ffffff;
    box-sizing: border-box;
    width: 100%;
`;

function CalendarMenu({
    range,
    setRange,
    onClose,
    setCustomValue,
    openedCalendarLeftSide,
    backgroundColor,
    noBlur,
    leftPositon = "-180px",
    notLeftPositon = "0",
}) {
    const [selectedType, setSelectedType] = useState("day");

    function handleCaptionClick() {
        console.log("Caption clicked, selectedType:", selectedType);
        if (selectedType === "day") {
            setSelectedType("month");
        } else if (selectedType === "month") {
            setSelectedType("year");
        }
    }

    const applyValue = () => {
        setCustomValue();
        onClose();
    };

    return (
        <CalendarWrapper
            openedCalendarLeftSide={openedCalendarLeftSide}
            $leftPositon={leftPositon}
            $notLeftPositon={notLeftPositon}
            backgroundColor={backgroundColor}
            $noBlur={noBlur}
        >
            <CalendarComponent
                range={range}
                setRange={setRange}
                type={selectedType}
                onCaptionClick={handleCaptionClick}
                setType={setSelectedType}
            />
            {selectedType === "day" && (
                <>
                    <Row width={"100%"} justifyContent={"space-between"} padding={"0 4px"}>
                        <Column
                            width={"50%"}
                            justifyContent={"flex-start"}
                            alignItem={"flex-start"}
                            padding={"0 5.5px"}
                        >
                            <Padding padding={"0 8px"}>
                                <C4Text fontColor={Theme.color.gray500}>From</C4Text>
                            </Padding>
                            <SizedBox height={"4px"} />
                            <DateInput name={"from"} value={range?.from ? format(range.from, "yyyy-MM-dd") : ""} />
                        </Column>
                        <Column
                            width={"50%"}
                            justifyContent={"flex-start"}
                            alignItem={"flex-start"}
                            padding={"0 5.5px"}
                        >
                            <Padding padding={"0 8px"}>
                                <C4Text fontColor={Theme.color.gray500}>To</C4Text>
                            </Padding>
                            <SizedBox height={"4px"} />
                            <DateInput name={"to"} value={range?.to ? format(range.to, "yyyy-MM-dd") : ""} />
                        </Column>
                    </Row>
                    <Divider marginTop={"12px"} />
                    <Row justifyContent={"flex-end"} padding={"12px"}>
                        <SecondaryButton text={"Cancel"} onClick={onClose} padding={"7.75px 10px"} width={"70px"} />
                        <SizedBox width={"7px"} />
                        <PrimaryButton text={"Apply"} onClick={applyValue} padding={"7.75px 10px"} width={"70px"} />
                    </Row>
                </>
            )}
        </CalendarWrapper>
    );
}

export default CalendarMenu;
